import { Grid } from "@material-ui/core";
import { useContasReceberService } from "../../context/ContasReceberContext";
import ReportTable from "./ReportTable";

const ReportDataGrid = () => {
  const { isGrouped, cachedMovementData } = useContasReceberService();

  if (!cachedMovementData.length) {
    return (
      <Grid item xs={12} style={{ marginBottom: 16 }} key={"empty-table"}>
        <ReportTable data={[]} emptyMessage="Sem Movimentação" />
      </Grid>
    );
  }

  return (
    <Grid item container>
      <Grid item xs={12}>
        <ReportTable
          data={cachedMovementData}
          emptyMessage="Sem Movimentação"
          isGrouped={isGrouped}
        />
      </Grid>
    </Grid>
  );
};

export default ReportDataGrid;
